import keys from 'i18n/keys';

export const HEAT_EXPORT_LABELS = [keys.DAY, keys.DATA, keys.AVG_TEMPERATURE] as const;
